 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c79ee6":"472b61ae","chunk-02c995b5":"8987b934","chunk-09155df3":"33810478","chunk-09162720":"0221ea15","chunk-097e0872":"2de0312c","chunk-0e93a01c":"e186a47a","chunk-106fab1a":"3c3715a5","chunk-12beba06":"ebbe18a5","chunk-1a04e9f0":"3fde94c6","chunk-1b36f5ab":"bc5f1a86","chunk-1dbc15a2":"926dcd64","chunk-1f073bb8":"38be6095","chunk-21a76241":"2e59aee3","chunk-22341d62":"36385dc3","chunk-22496fff":"0d383265","chunk-234940c6":"6ce43415","chunk-243e847e":"d636b3fd","chunk-247c7357":"148dbe40","chunk-25d83ca8":"21053b61","chunk-2d0a463b":"7f09541d","chunk-2d0ac931":"f4e0ee0c","chunk-2d0c073f":"8bbfc415","chunk-2d0c211b":"474a9aea","chunk-2d0cf315":"e659bcff","chunk-2d0d43da":"c9cb77c9","chunk-2d0da04a":"bab99e71","chunk-2d0e5812":"49ef1114","chunk-2d213189":"7129d9d4","chunk-2d217def":"9b86ebe8","chunk-2d217e6a":"3d0c08cc","chunk-2d218068":"5ad8fc28","chunk-2d21a9aa":"bdd6764c","chunk-2d21da73":"c021f761","chunk-2d222cca":"b8e77524","chunk-2d22895d":"904df80f","chunk-2d2304d2":"791aa685","chunk-2d23721e":"b74ac3c0","chunk-2d237b00":"4bc0e95a","chunk-30dd9750":"eb6ebfdc","chunk-37f2300e":"34b9dd44","chunk-3ed29de3":"4f052ef2","chunk-41c0f7a4":"66e077aa","chunk-45f4b14e":"90d25591","chunk-462c869e":"11857bd2","chunk-485adc83":"1738ea08","chunk-541ea42d":"eb93725f","chunk-54bbd082":"82c35774","chunk-54f23343":"eb644896","chunk-59d4c87c":"cb99d455","chunk-5a8ac886":"3f0f9c12","chunk-5ff96a24":"fac7b108","chunk-61a0c114":"16128646","chunk-65e1958a":"59a1027d","chunk-69eb8776":"0ad4078b","chunk-6a10b16f":"dd4a562a","chunk-6d375f34":"7de9f94b","chunk-7548ca2d":"a0e6f140","chunk-79f1dac7":"5666a24d","chunk-858cd918":"edc1c890","chunk-8bb7f81e":"dff158ca","chunk-8cf3d17c":"f2fc81b4","chunk-a9395c36":"3002a0db","chunk-d0e8aa0a":"33c6fc92","chunk-d8413eac":"c1259459","chunk-eaa2b130":"de89a243","chunk-ff897834":"9fc58ad4","chunk-237bc859":"374419d3","chunk-36de657c":"39db6744","chunk-3b8f5441":"70655369","chunk-ab7ef228":"42d53ec7","polyfills-core-js":"121f426d","polyfills-dom":"d8a6324a","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-2d0b33e3":"f159d0f5","chunk-2d0dd4c8":"2e32fb0a","chunk-2d0dd790":"b3a98d20","chunk-2d2176ae":"9e66aa1f","chunk-2d21d0c2":"ec000e4a","chunk-2d2376e6":"8db0e7a4","chunk-2d2297f7":"c4405f08"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-02c79ee6":1,"chunk-12beba06":1,"chunk-1a04e9f0":1,"chunk-1f073bb8":1,"chunk-234940c6":1,"chunk-243e847e":1,"chunk-247c7357":1,"chunk-45f4b14e":1,"chunk-61a0c114":1,"chunk-65e1958a":1,"chunk-6a10b16f":1,"chunk-237bc859":1,"chunk-36de657c":1,"chunk-3b8f5441":1,"chunk-ab7ef228":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c79ee6":"eee320d7","chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-106fab1a":"31d6cfe0","chunk-12beba06":"05460877","chunk-1a04e9f0":"d357ff9a","chunk-1b36f5ab":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-1f073bb8":"3171855d","chunk-21a76241":"31d6cfe0","chunk-22341d62":"31d6cfe0","chunk-22496fff":"31d6cfe0","chunk-234940c6":"b66be48b","chunk-243e847e":"31e7432f","chunk-247c7357":"a7e4f3fd","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-45f4b14e":"6dac12eb","chunk-462c869e":"31d6cfe0","chunk-485adc83":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-54f23343":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-61a0c114":"d5711e59","chunk-65e1958a":"469189c4","chunk-69eb8776":"31d6cfe0","chunk-6a10b16f":"cf84f308","chunk-6d375f34":"31d6cfe0","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-8cf3d17c":"31d6cfe0","chunk-a9395c36":"31d6cfe0","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","chunk-ff897834":"31d6cfe0","chunk-237bc859":"1d7c1cee","chunk-36de657c":"924076f2","chunk-3b8f5441":"ccf42e16","chunk-ab7ef228":"3a52a7f1","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0dd4c8":"31d6cfe0","chunk-2d0dd790":"31d6cfe0","chunk-2d2176ae":"31d6cfe0","chunk-2d21d0c2":"31d6cfe0","chunk-2d2376e6":"31d6cfe0","chunk-2d2297f7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
